import React from 'react';

import * as styles from './flash-item.scss';

export interface Flash {
  id: string;
  title: string | JSX.Element;
}

export interface Props {
  item: Flash;
}

export const FlashItem = ({ item }: Props) => (
  <div className={styles.root}>
    <div className={styles.container}>
      <div className={styles.inner}>
        <div className={styles.textContainer}>
          <span className={styles.itemTitle}>{item.title}</span>
        </div>
      </div>
    </div>
  </div>
);
